// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  version: require('../../../../package.json').version,
  apiVersion: require('../../../../package.json').apiVersion,
  baseAPIUrl: 'https://support-test.realaxiom.com/api',
  zendeskAPIUrl: 'https://elitesrl.zendesk.com/api/v2',
  knowledgeBaseUrl: 'https://elitesrl.zendesk.com',
  forumUrl: 'http://forum.elite-it.com',
  domain: 'support-test.realaxiom.com',
  legacyAPIUrl: 'http://testapp.realaxiom.com:8080',
  metAPIUrl: 'https://test-api.realaxiom.com/v1',
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
